/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { Attachment } from '@src/app/model/attachment';
import { Forum } from '@src/app/model/forum';

export class Document extends AbstractObject {
  title: string;
  content: string;
  forumId: uuid;
  forum: Forum;
  areaId: uuid;
  areaName: string;
  coreId: uuid;
  coreName: string;
  typeId: uuid;
  typeName: string;
  categoryId: uuid;
  categoryName: string;


  attachments: Attachment[] = [];
  childPages: Document[] = [];
  parentId: uuid;
  parent: Document;

  // Counts returned from server side... not sure they are numbers, remove comment if confirmed...
  child_docs_count?: number;
  attachments_count?: number;

  constructor(o: Partial<Document> = {}) {
    super(o);
  }
}
